import { Typography } from '@material-ui/core';
import React from 'react';
import EntityTabs, { IEntityTabsProps } from '../../Layout/Components/EntityTabs/EntityTabs';
import { MainPictureTabIcon, AboutUsTabIcon, LogoTabIcon, PriceTagIcon } from '../../Layout/Components/Icons';
import { useTranslation } from 'react-i18next';
import GraphicsTable from './GraphicsTable';
import { DictImageType } from '../../API/Interfaces/Enums';
import { imageDimensions, UserRole } from '../../Constants/constants';
import { UserContext } from '../../Context/UserContext';
import { isInRole } from '../../Utils/roleChecker';

export const Graphics = () => {
	const userContext = React.useContext(UserContext);
	const hasEditRights =
		isInRole(userContext.userRoles, UserRole.SuperAdmin) ||
		isInRole(userContext.userRoles, UserRole.CorporationAdmin) ||
		isInRole(userContext.userRoles, UserRole.DealerAdmin);
	const { t } = useTranslation();

	const entityTabsProps: IEntityTabsProps = {
		tabs: [
			{
				header: {
					icon: <MainPictureTabIcon />,
					label: t('repository.mainTab'),
					visible: true,
				},
				content: (
					<GraphicsTable
						title={t('repository.mainTab')}
						imageType={DictImageType.MainPicture}
						imageDimensions={imageDimensions.mainImage}
						hasEditRights={hasEditRights}
					/>
				),
			},
			{
				header: {
					icon: <AboutUsTabIcon />,
					label: t('repository.aboutTab'),
					visible: true,
				},
				content: (
					<GraphicsTable
						title={t('repository.aboutTab')}
						imageType={DictImageType.AboutPicture}
						imageDimensions={imageDimensions.aboutUsImage}
						hasEditRights={hasEditRights}
					/>
				),
			},
			{
				header: {
					icon: <LogoTabIcon />,
					label: t('repository.logoTab'),
					visible: true,
				},
				content: (
					<GraphicsTable
						title={t('repository.logoTab')}
						imageType={DictImageType.Logo}
						imageDimensions={imageDimensions.logo}
						hasEditRights={hasEditRights}
					/>
				),
			},
			{
				header: {
					icon: <PriceTagIcon />,
					label: t('repository.sidePictureTab'),
					visible: true,
				},
				content: (
					<GraphicsTable
						title={t('repository.sidePictureTab')}
						imageType={DictImageType.SidePicture}
						imageDimensions={imageDimensions.sidePicture}
						hasEditRights={hasEditRights}
					/>
				),
			},
		],
	};

	return (
		<>
			<Typography variant='h6' style={{ margin: '30px' }}>
				{t('menu.graphics')}
			</Typography>
			<div style={{ margin: '0 30px 30px 30px' }}>
				<EntityTabs {...entityTabsProps} />
			</div>
		</>
	);
};

export default Graphics;
